module.exports = __webpack_public_path__ + "assets/img/img103.cad2b441.png";